<template>
  <span>
    <b-sidebar
      sidebar-class="big_sidebar"
      id="add-nuiteq-meeting"
      v-model="show"
      right
      backdrop
      no-slide
      lazy
      shadow
      no-header-close
      no-close-on-backdrop
      no-close-on-esc
      @shown="shown"
      @hidden="closeBtn"
    >
      <div class="pt-4 pb-4">
        <b-overlay :show="loading" rounded="sm">
          <div v-if="settings" class="px-3 py-2 view-content create-message">
            
            <div class="clearfix">
              <b-img src="/img/external/nuiteq.svg" width="150px" right class="mb-2"></b-img>
            </div>

            <div v-if="!nuiteqAuthenticated">
              <b-form-input trim
                class="mt-2"
                input-id="subject"
                autocomplete="off"
                :placeholder="$t('USERNAME')"
                v-model="username"
              ></b-form-input>

              <b-form-input trim
                class="mt-2"
                type="password"
                input-id="subject"
                autocomplete="off"
                :placeholder="$t('PASSWORD')"
                v-model="password"
              ></b-form-input>

              <hr class="p-0 m-0 mt-2 mb-2" />

              <b-button @click="closeBtn">{{ $t("CLOSE") }}</b-button>

              <b-button
                @click="authenticatedBtn"
                variant="primary"
                class="btn-fill"
                >{{ $t("LOGIN") }}</b-button
              >
            </div>
            <div v-if="nuiteqAuthenticated">
              <div v-show="step == 1">

                <div v-if="settings.user_meetings_enabled">
                  <div v-if="!selectedMeeting" class="mb-2">
                    {{ $t("NONE_SELECTED") }}
                  </div>

                  <div v-if="selectedMeeting" class="mb-2 sdk-recipient">
                    {{ selectedMeeting.name }}
                  </div>

                  <b-button
                    size="sm"
                    variant="primary"
                    @click="generateStageMeeting"
                  >
                    {{ $t("NUITEQ.GENERATE_MEETING") }}
                  </b-button>

                  <b-button
                    size="sm"
                    variant="primary"
                    @click="viewMeetings"
                  >
                    {{ $t("NUITEQ.CREATED_MEETING_IN_STAGE") }}
                  </b-button>

                  <b-button
                    size="sm"
                    variant="primary"
                    v-b-modal.save-new-meeting
                  >
                    <i class="fal fa-plus"></i>
                    {{ $t("NUITEQ.CREATE_MEETING") }}
                  </b-button>
                </div>

                <div class="info-header mt-2">{{ $t("ADD_RECIPIENTS") }}</div>

                <SearchRecipients
                  class="w-100 mt-2"
                  user_uuid=""
                  functionbox_uuid=""
                  v-model="addresses"
                  :key="'forceRedrawRecipientsKey_' + forceRedrawRecipientsIndex"
                  @forceRedraw="forceRedrawRecipientsIndex++"
                ></SearchRecipients>

                <b-form-input trim
                  class="mt-2 pl-2"
                  input-id="subject"
                  id="subject"
                  :disabled="settings.subject != ''"
                  :placeholder="$t('SUBJECT')"
                  :state="subject.length <= 256"
                  autocomplete="off"
                  v-model="subject"
                ></b-form-input>
                <div class="clearfix">
                  <div class="float-left">
                    <div class="error-text" v-if="subject.length > 256">
                      {{ $t("ERROR.TOO_MANY_CHARACTERS") }}
                    </div>
                    <b-form-text id="subject" v-if="settings.subject == ''">
                      {{ $t("SUBJECT_EMAIL") }}
                    </b-form-text>
                    <b-button
                      v-if="settings.subject != '' && settings.unlock_subject"
                      @click="unlockSubject"
                      size="sm"
                      class="no-border mt-2 mb-2"
                      ><i class="fal fa-unlock"></i>
                      {{ $t("BTN_UNLOCK_SUBJECT") }}</b-button
                    >
                  </div>
                  <div class="float-right">
                    <div class="text-right">
                      <small class="pull-right">{{ subject.length }}/256</small>
                    </div>
                  </div>
                </div>

                <div>
                  <h6 class="mt-2">{{ $t("MESSAGES.EXTERNAL_TEXT") }}</h6>
                  <div class="mt-2 mb-2">
                    <b-form-textarea
                      class="textarea"
                      id="externalText"
                      ref="externalText"
                      :state="external_text.length <= 1500"
                      v-model="external_text"
                      :disabled="settings.email_body != ''"
                      :placeholder="$t('MESSAGES.EXTERNAL_TEXT_PLACEHOLDER')"
                      rows="3"
                      max-rows="3"
                    ></b-form-textarea>
                    <div class="clearfix">
                      <div class="float-left">
                        <div
                          class="error-text"
                          v-if="external_text.length > 1500"
                        >
                          {{ $t("ERROR.TOO_MANY_CHARACTERS") }}
                        </div>
                        <b-form-text
                          id="email_body"
                          v-if="settings.email_body == ''"
                        >
                          {{ $t("MESSAGES.EXTERNAL_TEXT_INFORMATION") }}
                          {{ $t("MESSAGES.EXTERNAL_TEXT_INFORMATION_SMS") }}
                        </b-form-text>
                        <b-button
                          v-if="
                            settings.email_body != '' &&
                            settings.unlock_email_body
                          "
                          @click="unlockEmailBody"
                          size="sm"
                          class="no-border mt-2 mb-2"
                          ><i class="fal fa-unlock"></i>
                          {{ $t("BTN_UNLOCK_EMAIL_BODY") }}</b-button
                        >
                      </div>
                      <div class="float-right">
                        <div class="text-right">
                          <small class="pull-right"
                            >{{ external_text.length }}/1500</small
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <PickDateTime
                  @changedFrom="changeFromDate"
                  @changedTo="changeToDate"
                ></PickDateTime>

                <small>{{ $t("MEETINGS.BEFORE") }}</small>

                <hr class="p-0 m-0 mt-2 mb-2" />

                <b-button @click="closeBtn">{{ $t("CLOSE") }}</b-button>

                <b-button
                  :disabled="disabledStep2"
                  @click="gotoStep2"
                  variant="primary"
                  class="btn-fill"
                  >{{ $t("NEXT") }}</b-button
                >
              </div>
              <div v-show="step == 2">
                {{ $t("MESSAGES.NOT_REGISTERED_INFORMATION") }}
                <div v-if="showExternal">
                  <div class="mt-2" :key="step1index">
                    <div
                      v-for="(item, index) in external_participants"
                      :key="index"
                      class="NotRegistered"
                    >
                      <NotRegistered
                        @setValidated="setValidated"
                        :methods="methods"
                        :loa_level="loa_level"
                        :item="item"
                        :index="index"
                        :show-sefos="showSefos(item)"
                      ></NotRegistered>
                    </div>
                  </div>

                  <hr class="p-0 m-0 mt-2 mb-2" />

                  <b-button @click="gotoStep1">{{ $t("BACK") }}</b-button>
                  <b-button
                    :disabled="disabledSend"
                    @click="sendMeeting()"
                    variant="primary"
                    class="btn-fill"
                    >{{ $t("SUBMIT") }}</b-button
                  >
                </div>
              </div>
              <div v-show="step == 22">
                <div :key="meetingsNotInTrash.length">
                  <b-button class="no-border" @click="getMeetings"
                    ><i class="fal fa-sync"></i
                  ></b-button>
                  {{ $t("NUITEQ.SELECT_MEETING") }}

                  <b-table
                    striped
                    hover
                    per-page="10"
                    @row-clicked="setMeeting"
                    :current-page="currentMeetingPage"
                    :items="meetingsNotInTrash"
                    :fields="nuiteqMeetingsFields"
                  >

                  <template v-slot:cell(name)="data">
                    <b-button variant="primary" target="blank" size="sm" @click="setMeeting(data.item)">{{ $t('USE') }}</b-button>
                    {{  data.item.name }}
                  </template>

                  <template v-slot:cell(id)="data">
                    <b-button variant="primary" target="blank" size="sm" @click="joinBoard(data.item.id)">{{ $t('JOIN') }}</b-button><span class="hidden-not-mobile">{{ data.item.name }}</span>
                  </template>

                  </b-table>

                  <b-pagination
                    v-model="currentMeetingPage"
                    :total-rows="meetingsNotInTrash.length"
                    per-page="10"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>

                <b-button @click="cancelSelectMeeting">{{
                  $t("CANCEL")
                }}</b-button>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </b-sidebar>

    <b-modal
      id="save-new-meeting"
      hide-header
      @cancel="cancelSave"
      @hidden="closedNewMeeting"
      @ok="okSave"
      centered
      :key="'SaveMeeting' + SaveMeetingIndex"
      :ok-disabled="meetingName == ''"
      :cancel-title="$t('CANCEL')"
      :ok-title="$t('SAVE')"
    >
      <b-img src="/img/external/nuiteq.svg" alt="nuiteq logo" class="mb-2"></b-img>
      <div>
        {{ $t("NUITEQ.CREATE_MEETING_TITLE") }}


        <b-form-input trim
          :placeholder="$t('NUITEQ.MEETING_NAME')"
          v-model="meetingName"
          autocomplete="off"
          :name="meetingNameInput"
        ></b-form-input>

        <b-form-input
          class="mt-2"
          @click="meetingPasswordType = 'password'"
          :type="meetingPasswordType"
          autocomplete="off"
          @blur="meetingPasswordBlur"
          :name="meetingPasswordInput"
          :placeholder="$t('PASSWORD')"
          v-model="meetingPassword"
        ></b-form-input>

        <b-form-checkbox
          id="nuiteq-meeting-waiting-room"
          class="mt-2"
          v-model="meetingWaitingroom"
          name="checkbox-1"
          :value="true"
          switch
          :unchecked-value="false"
        >
          {{ $t("NUITEQ.WAITING_ROOM_ACTIVE") }}
        </b-form-checkbox>

      </div>
    </b-modal>
  </span>
</template>
<script>
import PickDateTime from "@/components/Compose/PickDateTime";
import * as blobUtil from "blob-util";
import SearchRecipients from "@/components/Compose/SearchRecipients";
import NotRegistered from "@/components/Compose/NotRegistered";
export default {
  props: ["show"],
  components: {
    SearchRecipients,
    NotRegistered,
    PickDateTime,
  },
  data() {
    return {
      SaveMeetingIndex: 0,
      meetingNameInput: 'meetingNameInput_' + Date.now(),
      meetingPasswordInput: 'meetingPasswordInput' + Date.now(),
      meetingPasswordType: 'text',
      settings: null,
      forceRedrawRecipientsIndex: 0,
      currentMeetingPage: 1,
      selectedMeeting: null,
      nuiteqMeetings: [],
      nuiteqMeetingsFields: [
        {
          key: "name",
          label: this.$t("NAME"),
          class: "text-break clickable hidden-mobile",
          sortable: false,
        },
        {
          key: "password",
          label: this.$t('PASSWORD'),
          class: "text-break clickable",
          sortable: false,
        },
        {
          key: "id",
          label: "",
          class: "text-break clickable",
          sortable: false,
        }
      ],
      registered: [],
      notregistered: [],
      meeting: "",
      username: "",
      password: "",
      addedIndex: 0,
      message_uuid: "",
      step1index: 0,
      validated: [],
      step: 1,
      content: "",
      subject: "",
      loa_level: 1,
      meeting_from: "",
      meeting_to: "",
      addresses: [],
      files: [],
      methods: [],
      loading: false,
      attachments: [],
      showExternal: false,
      participants: [],
      external_text: "",
      external_participants: [],
      process: 1,
      meetings: [],
      boardId: "",
      nuiteqAuthenticated: false,
      meetingName: "",
      meetingPassword: "",
      meetingWaitingroom: false
    };
  },
  methods: {
    meetingPasswordBlur(){
      if(this.meetingName == '')
      {
        this.meetingPasswordType = "text";
      }
    },
    closedNewMeeting(){
      this.SaveMeetingIndex++;
      this.cancelSave();
    },
    unlockSubject() {
      this.subject = this.settings.subject;
      this.settings.subject = "";
      this.settings.unlock_subject = 0;
    },
    unlockEmailBody() {
      this.settings.email_body = "";
      this.settings.unlock_email_body = 0;
    },
    showSefos(item) {
      return this.registered.includes(item.email);
    },
    changeFromDate(val) {
      this.meeting_from = val;
    },
    changeToDate(val) {
      this.meeting_to = val;
    },
    generateStageMeeting() {
      this.selectedMeeting = {
        id: "",
        name: this.$t("NUITEQ.GENERATED_MEETING"),
      };
    },
    viewMeetings() {
      this.getMeetings();
      this.step = 22;
    },
    setMeeting(item) {
      this.selectedMeeting = item;
      this.step = 1;
    },
    cancelSelectMeeting() {
      this.step = 1;
    },
    shown() {      
      this.getSettings();
    },    
    async joinBoard(boardId)
    {
      try {
        let result = await this.$http.get(this.user.hostname + "/nuiteq/connect/" + boardId);
        console.log(result);
        window.open(result.data);
      } catch {
        console.log("Could not join Board");
      }        
    },
    getSettings() {
      let self = this;
      self.loading = true;
      this.$http
        .post(this.user.hostname + "/settings/get", {
          setting: "Nuiteq",
          organisation_uuid: this.user.information.organisation.organisation_uuid,
          functionbox_uuid: this.functionbox_uuid,
        }
        )
        .then(function (result) {
          self.settings = result.data;
          self.loading = false;
          self.init();
        })
        .catch(function () {
          self.loading = false;
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH"));
        });
    },
    async okSave() {
      let self = this;
      self.loading = true;
      let NuiteqMeetingDTO = {
        name: this.meetingName,
        password: this.meetingPassword,
        waitingRoom: this.meetingWaitingroom,
      };
      await this.$http
        .post(this.user.hostname + "/nuiteq/new", NuiteqMeetingDTO)
        .then(function (result) {
          self.$noty.info(self.$t("SAVED"));
          self.cancelSave();
          self.boardId = result.data.boardId;
          self.selectedMeeting = {
            name: NuiteqMeetingDTO.name,
            id: self.boardId,
          };
          self.loading = false;
          self.cancelSave();
        })
        .catch(function (error) {
          self.loading = false;
          if (error.response != undefined) {
            self.$noty.error(self.$t(error.response.data));
          }
        });
    },
    cancelSave() {
      this.meetingName = "";
      this.meetingPassword = "";
      this.meetingWaitingroom = false;
      this.meetingPasswordType = "text";
    },
    authenticatedBtn() {
      let self = this;
      this.$http
        .post(this.user.hostname + "/nuiteq/login", {
          username: this.username,
          password: this.password,
        })
        .then(function (response) {
          if(response.data == false)
          {
            self.$noty.error(self.$t("ERROR.CANNOT_LOGIN"));
          }
          self.nuiteqAuthenticated = response.data;
        })
        .catch(function () {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH"));
        });
    },
    getAuthenticated() {
      let self = this;
      this.$http
        .get(this.user.hostname + "/nuiteq/authenticated")
        .then(function (result) {
          self.nuiteqAuthenticated = result.data;
          if (result.data) {
            self.getMeetings();
         } else {
            self.username = self.user.information.email;
          }
        })
        .catch(function () {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH"));
        });
    },
    getMeetings() {
      let self = this;
      this.$http
        .get(this.user.hostname + "/nuiteq/list")
        .then(function (result) {
          self.nuiteqMeetings = result.data;
        })
        .catch(function () {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH"));
        });
    },
    searchedUser(email) {
      if (!this.addresses.includes(email)) {
        this.addresses.push(email);
      }
    },
    async closeBtn() {
      this.$emit("changeShow", false);
      this.$emit("sentMeeting");
    },
    async init() {
      if (this.settings.subject != "") {
        this.subject = this.settings.subject;
      }
      if (this.settings.email_body != "") {
        this.external_text = this.settings.email_body;
      } else {
        if (this.user.information.signature != "") {
          this.external_text =
            "\n\n----------------------------\n" +
            this.user.information.signature;
        }
        /*setTimeout(() => {          
          let input = document.getElementById("externalText");
          if(input != null)
          {
            input.setSelectionRange(0, 0);
          }
        }, 500);*/
      }
      await this.getAuthenticated();
      await this.getMethods();
    },
    async gotoStep1() {
      this.step = 1;
      this.loading = false;
    },
    async gotoStep2() {
      this.loading = true;
      this.validated = [];
      this.external_participants = [];
      let result = await this.$http.post(
        this.user.hostname + "/meeting/check-registered",
        {
          emails: this.addresses,
        }
      );
      this.registered = result.data.registered;
      for (let ix = 0; ix < this.addresses.length; ix++) {
        this.external_participants.push({
          email: this.addresses[ix],
          authentication_method: "link",
          authentication_identifier: "",
          language: this.$i18n.locale,
        });
        this.validated.push({
          email: this.addresses[ix],
          valid: 1,
        });
      }
      this.showExternal = true;
      this.step = 2;
      this.loading = false;
    },
    authenticationImage(authentication_method) {
      return "/img/auth/" + authentication_method + ".png";
    },
    async getMethods() {
      let self = this;
      await this.$http
        .get(this.user.hostname + "/authenticate/external/methods")
        .then(function (result) {
          self.methods = result.data;
          self.loading = false;
        })
        .catch(function (error) {
          self.loading = false;
          self.$noty.error(self.$t(error.response));
        });
    },
    async verifyExternal() {
      if (this.external_participants.length == 0) {
        return true;
      }
      for (let ix = 0; ix < this.external_participants.length; ix++) {
        let external_participant = this.external_participants[ix];
        if (
          external_participant.authentication_method == "sms" &&
          external_participant.authentication_identifier == ""
        ) {
          return false;
        }
        if (
          external_participant.authentication_method == "bankid-se" &&
          external_participant.authentication_identifier == ""
        ) {
          return false;
        }
        if (
          external_participant.authentication_method == "freja" &&
          external_participant.authentication_identifier == ""
        ) {
          return false;
        }
      }
      return true;
    },
    setValidated(payload) {
      if (payload.value) {
        this.validated[payload.index].valid = 1;
      } else {
        this.validated[payload.index].valid = 0;
      }
    },
    async sendMeeting() {
      try {
        this.loading = true;
        let self = this;
        this.$http
          .post(this.user.hostname + "/nuiteq/secure", {
            send_creator: 1,
            subject: this.subject,
            body: this.content,
            boardId: this.selectedMeeting.id,
            attachments: this.attachments,
            participants: this.participants,
            external_text: this.external_text,
            external_participants: this.filteredParticipants,
            settings: {
              require_response: 0,
              loa_level: 1,
              open_to_date: this.meeting_to,
              open_from_date: this.meeting_from,
            },
          })
          .then(function (result) {
            self.attachments = [];
            self.message_uuid = result.data.message_uuid;
            self.loading = false;
            self.$noty.info(self.$t("SENT_MEETING"));
            self.closeBtn();
            /*
            if (result.data.all_sent != undefined) {
              if (result.data.all_sent) {
                self.$noty.info(self.$t("SENT_MEETING"));
              } else {
                self.$noty.warning(self.$t("SENT_MEETING_NOT_SENT"));
              }
            } else {
              self.$noty.info(self.$t("SENT_MEETING"));
            }*/
          })
          .catch(function () {
            self.loading = false;
            self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
          });
      } catch (error) {
        throw error;
      }
    },
    downloadICS: function (message_uuid) {
      let name = "meeting.ics";
      let self = this;
      this.$http
        .get(this.user.hostname + "/jitsi/ics/" + message_uuid)
        .then((response) => {
          let blob = blobUtil.arrayBufferToBlob(response.data, "text/calendar");
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, name);
          } else {
            let $link = document.createElement("a");
            let url = URL.createObjectURL(blob);
            $link.setAttribute("target", "_blank");
            $link.setAttribute("href", url);
            $link.setAttribute("download", name);
            $link.style.visibility = "hidden";
            document.body.appendChild($link);
            $link.click();
            document.body.removeChild($link);
            self.$emit("sentMeeting");
          }
        })
        .catch(function () {
          self.$emit("sentMeeting");
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  computed: {
    meetingsNotInTrash() {
      let filtered = this.nuiteqMeetings.filter(function (item) {
        return item.trash == false;
      });
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      return filtered.sort(compare);
    },
    disabledStep2: function () {
      if(!this.selectedMeeting)
      {
        return true;
      }
      if (this.external_text.length >= 1500) {
        return true;
      }
      if (this.subject.length >= 256) {
        return true;
      }
      if (!this.selectedMeeting) {
        return true;
      }
      if (this.meeting_from >= this.meeting_to) {
        return true;
      } else {
        if (this.addresses.length != 0 && this.subject != "") {
          return false;
        } else {
          return true;
        }
      }
    },
    disabledSend: function () {
      if (
        this.filteredParticipants.length == 0 &&
        this.registered.length == 0
      ) {
        return true;
      } else {
        if (this.external_participants.length != 0) {
          if (
            this.external_participants.length ==
            this.validatedParticipants.length
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      }
    },
    canVerify() {
      if (this.addresses.length == 0) {
        return false;
      }
      if (this.subject == "") {
        return false;
      }
      return true;
    },
    filteredParticipants() {
      return this.external_participants.filter(function (item) {
        return item.authentication_method !== "donotsend";
      });
    },
    filteredRemovedParticipants() {
      return this.external_participants.filter(function (item) {
        return item.authentication_method == "donotsend";
      });
    },
    validatedParticipants() {
      return this.validated.filter(function (item) {
        return item.valid == 1;
      });
    },
  },
  mounted() {},
};
</script>
